//#region types
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModelCustomFilters } from "wint-api-client/dist/types";
//#endregion
import useAPIClientHelper from "./useAPIClientHelper";
import { ServiceHelper } from "utils/helpers";

function useFilterService() {
  const { apiClientInstance } = useAPIClientHelper();

  const saveFilter = (
    name: string,
    filterType: WintSuperkollAPIModelCustomFilters.FilterCategory,
    filter: any,
    isDefault: boolean,
    returnRelativeDates: boolean
  ) => {
    return apiClientInstance(AuthEnums.AuthType.Company).FilterClient.Create({
      name: name,
      filterData: filter,
      type: filterType,
      isDefault,
      returnRelativeDates,
    });
  };

  const updateFilter = (id: number, name: string, filter: any, isDefault: boolean, returnRelativeDates: boolean) => {
    return apiClientInstance(AuthEnums.AuthType.Company).FilterClient.Update(id, {
      name,
      filterData: filter,
      isDefault,
      returnRelativeDates,
    });
  };

  const loadFiltersOfType = (filterType: WintSuperkollAPIModelCustomFilters.FilterCategory) => {
    return ServiceHelper.getAllPages((page) =>
      apiClientInstance(AuthEnums.AuthType.Company).FilterClient.Get({
        types: [filterType],
        page: page,
        isAutoPaginating: false,
        orderByDescending: false,
        thenByDescending: false,
      })
    );
  };

  const deleteFilter = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company).FilterClient.Remove(id);
  };

  return {
    saveFilter,
    updateFilter,
    loadFiltersOfType,
    deleteFilter,
  };
}

export default useFilterService;
